/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Description_PlaceholderInputs */

const en_admin_categories_description_placeholder = /** @type {(inputs: Admin_Categories_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional description`)
};

const zh_admin_categories_description_placeholder = /** @type {(inputs: Admin_Categories_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可选描述`)
};

/**
* | output |
* | --- |
* | "Optional description" |
*
* @param {Admin_Categories_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_description_placeholder = /** @type {((inputs?: Admin_Categories_Description_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Description_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_description_placeholder(inputs)
	return zh_admin_categories_description_placeholder(inputs)
});
export { admin_categories_description_placeholder as "admin.categories.description_placeholder" }